import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const createRequisition = ({ churchId, requisitionData }) => {
  return axios.post(`/churches/${churchId}/requisitions`, requisitionData);
};

export const useCreateRequisition = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("requisitions");

      setNotification({
        type: "success",
        message: "Requisition created successfully!"
      });

      navigate("/finances/temp/expense/requisition");
    },
    ...config,
    mutationFn: createRequisition
  });
};
